import React from "react";
import ReactDOM from "react-dom/client";
import {
  HashRouter,

} from "react-router-dom";
import "./index.css";
import App from "./App";
import NavBar from "./components/NavBar";
import Topper from "./components/Topper";
import ProjectGrid from "./components/ProjectGrid";
import reportWebVitals from "./reportWebVitals";
import Footer from "./components/Footer";
import "@fontsource/playfair-display";
import About from "./components/About";
import ScrollToTop from "./ScrollToTop.js";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>

    <HashRouter>
          <ScrollToTop></ScrollToTop>
      <App />
    </HashRouter>


    {/* <App /> */}
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
